import React from 'react';

const MigrationContent = () => (
  <section>
    <p>
      Por tareas de mantenimiento, nuestros canales digitales no estarán disponibles desde el
      viernes 20 a las 00 hasta el sábado 21 de junio.
    </p>
    <p>
      Vamos a enviarte un mail con las indicaciones necesarias para asegurar la atención de nuestros
      socios.
    </p>
    <p>¡Gracias por tu comprensión!</p>
  </section>
);

export default MigrationContent;
